module.exports = __webpack_public_path__ + "img/Business_France_logo.56128d0d.png";